<template>
    <retailer-logos-grid-section
        class="retailer-logos-grid-section-module"
        :retailers="retailers"
    />
</template>

<script>
    import RetailerLogosGridSection from '../../../organisms/RetailerLogosGridSection/RetailerLogosGridSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'retailer-logos-grid-section-module',

        components: { RetailerLogosGridSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Format the logos for the LogosGridSectionModule.
             *
             * @returns {{logo: {src: string, alt: string}, name: string, link: string, id: number}[]}
             */
            retailers() {
                return (this.attributes.retailers || []).map((retailer) => ({
                    id: retailer.id,
                    name: retailer.name,
                    logo: formatMediaObject.call(this, retailer.logo),
                    link: retailer.link,
                }));
            },
        },
    };
</script>
